import VueI18n from 'vue-i18n';

/**
 * Translate `key`, falling back to `fallback` when the key is missing.
 * Handy for enum labels where the backend sends the raw value and the FE
 * supplies the display string (e.g. assignment `type`).
 */
export function translateOrFallback(i18n: VueI18n, key: string, fallback: string): string {
  return i18n.te(key) ? (i18n.t(key) as string) : fallback;
}
